import React, {useState} from "react"
import {RouterSwitch} from "./RouterSwitch";
import {Route} from "react-router";
import {Navigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Drawer from "./drawer/Drawer";
import Footer from "./Footer";
import Content from "./Content";
import Notifications
  from "../../../../common/src/components/widget/Notifications";
import Error404 from "./Error404";
import TopBar from "./TopBar";
import BreadCrumbsStateful from "./BreadCrumbsStateful";
import OfferList from "../pages/offers/OfferList";
import OfferDetailsPage from "../pages/offers/OfferDetailsPage";
import StageList from "../pages/stage/StageList";
import StageDetails from "../pages/stage/StageDetails";
import PrivacyPolicy from "../pages/terms_and_privacy/PrivacyPolicy"
import TermsOfUse from "../pages/terms_and_privacy/TermsOfUse"
import RequestList from "../pages/request/RequestList";
import {UserContext} from '../../context/UserContext'
import Auth from "../../auth/Auth";
import ContactAdministratorError from "./ContactAdministratorError";
import RequestDetailsPage from "../pages/request/RequestDetailsPage";
import UserProfile from "../pages/profile/UserProfile";
import RequestFormPage from "../pages/request/RequestFormPage";

export const RouteContext = React.createContext(null);

const ApplicationStateful = () => {
  const {t} = useTranslation();
  const routesState = useState({routes: [], breadcrumbs: []});
  const [user, setUser] = useState({})

  return (
    <RouteContext.Provider value={routesState}>
      <UserContext.Provider value={{user, setUser}}>
        <Auth>
          <Notifications>
            <TopBar/>
            <Drawer url={"this.props.location.pathname"}/>
            <div id="main-section" className="is-main-section-container">
              <Content>
                <BreadCrumbsStateful/>
                <RouterSwitch>
                  <Route path="/stage" name={t("stages")}>
                    <Route index element={<StageList/>}/>
                    <Route path="edit/:stageDetailsId" name={t("edit")}
                           element={<StageDetails/>}/>
                    <Route path="create" name={t("create")} element={<StageDetails/>}/>
                  </Route>
                  <Route path="/" element={<Navigate to="/request"/>}/>

                  <Route path="/request" name={t("requests")}>
                    <Route index element={<RequestList/>}/>
                    <Route path="edit/:requestId" name={t("edit")}
                           element={<RequestDetailsPage/>}/>
                    <Route path="create" name={t("create")} element={<RequestFormPage />} />
                  </Route>
                  <Route path="/profile" name={t("my_profile")}
                         element={<UserProfile/>}/>
                  <Route path="/offers" name={t("offers")}>
                    <Route index element={<OfferList/>}/>
                    <Route path="edit/:offerId" name={t("edit")} element={<OfferDetailsPage/>}/>
                    <Route path="create/request/:requestId" name={t("create")} element={<OfferDetailsPage/>}/>
                  </Route>
                  <Route path="account-error"
                         element={<ContactAdministratorError/>}/>
                  <Route path="/terms" element={<TermsOfUse/>}/>
                  <Route path="/privacy" element={<PrivacyPolicy/>}/>
                  <Route path="*" element={<Error404/>}/>
                </RouterSwitch>
              </Content>
              <Footer/>
            </div>
          </Notifications>
        </Auth>
      </UserContext.Provider>
    </RouteContext.Provider>
  )
}

export default ApplicationStateful;

